import { reset } from "redux-form";
import { NotifError, NotifReactif } from "./notification";
import React, { forwardRef } from "react";
// import compress from "compress-base64";
import Resizer from "react-image-file-resizer";
import * as moment from "moment-timezone";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode-generator";
import { AppMode, findModule } from "./library";
import { doDecrypt, doEncrypt } from "./encrypt";

export function convertDate(tgl) {
  return formatDate(moment(new Date(tgl)).format("YYYY-MM-DD"));
}

export function convertDateNota(tgl) {
  let date = new Date(tgl);
  let bulan = "";
  // eslint-disable-next-line
  switch (date.getMonth()) {
    case 0:
      bulan = "Januari";
      break;
    case 1:
      bulan = "Februari";
      break;
    case 2:
      bulan = "Maret";
      break;
    case 3:
      bulan = "April";
      break;
    case 4:
      bulan = "Mei";
      break;
    case 5:
      bulan = "Juni";
      break;
    case 6:
      bulan = "Juli";
      break;
    case 7:
      bulan = "Agustus";
      break;
    case 8:
      bulan = "September";
      break;
    case 9:
      bulan = "Oktober";
      break;
    case 10:
      bulan = "November";
      break;
    case 11:
      bulan = "Desember";
      break;
  }
  let hasil = date.getDate() + " " + bulan + " " + date.getFullYear();
  return hasil;
}

export const generateQRCode = (text) => {
  // Create a QR code instance
  const qr = QRCode(0, "L");

  // Set the data for the QR code
  qr.addData(text);
  qr.make();

  // Create a canvas element and draw the QR code on it
  const canvas = document.createElement("canvas");
  canvas.id = "qrcodeCanvas"; // Unique identifier
  const context = canvas.getContext("2d");
  const cells = qr.getModuleCount();
  const cellSize = 2;

  canvas.width = cells * cellSize;
  canvas.height = cells * cellSize;

  for (let row = 0; row < cells; row++) {
    for (let col = 0; col < cells; col++) {
      context.fillStyle = qr.isDark(row, col) ? "black" : "white";
      context.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
    }
  }

  return canvas;
};
export const generateBarcode = (text) => {
  const canvas = document.createElement("canvas");
  canvas.id = "barcodeCanvas"; // Unique identifier
  JsBarcode(canvas, text, {
    format: "CODE128",
    displayValue: false,
    width: 2,
    height: 40,
  });
  return canvas;
};
export const CustomeInputDate = forwardRef(({ value, onClick }, ref) => (
  <>
    <div className="input-group mb-3">
      <input
        type="text"
        defaultValue={value}
        readOnly
        className="form-control"
        placeholder="Masukan Tanggal"
        aria-label="Masukan Tanggal"
        aria-describedby="basic-addon2"
      />
      <div className="input-group-append">
        <span className="input-group-text" id="basic-addon2">
          <i
            onClick={onClick}
            ref={ref}
            className="fa fa-calendar-alt"
            style={{ cursor: "pointer" }}
          ></i>
        </span>
      </div>
    </div>
  </>
));

export const isPos = () => {
  const version = AppMode;
  if (version === "POS") {
    return true;
  } else {
    return false;
  }
};

export const resizeFile = (file) =>
  new Promise((resolve, reject) => {
    Resizer.imageFileResizer(
      file,
      720,
      1366,
      "JPEG",
      50,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

export const dataURLtoFile = (dataurl, filename) => {
  // export const dataURLtoFile = (dataurl, filename) =>
  let arr = dataurl.split(","),
    // mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename + ".jpg", { type: "image/jpg" });
};
export const hiddenRecod = (text) => {
  let hasil = "";
  if (Number(text) === 0) {
    hasil = `  `;
  } else {
    hasil = text;
  }
  return hasil;
};
export const setItem = (nama, data) => {
  localStorage.setItem(nama, JSON.stringify(data));
};
export const getItem = (nama) => {
  if (nama === "module") {
    return localStorage.getItem(nama) === null
      ? []
      : JSON.parse(localStorage.getItem(nama) || "");
  } else {
    return localStorage.getItem(doEncrypt(nama)) === null
      ? []
      : JSON.parse(doDecrypt(localStorage.getItem(doEncrypt(nama))) || "");
  }
};
export const getToday = () => {
  return (
    new Date().getFullYear() +
    "-" +
    ("0" + (new Date().getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + new Date().getDate()).slice(-2)
  );
};
export const getTglSystem = () => {
  return getUserdata().tgl_system;
};

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const localStorageencryp = (nama, data) => {
  localStorage.setItem(encryptascii(nama), encryptascii(data));
};
export const localStoragedecryp = (nama) => {
  return decryptascii(localStorage.getItem(encryptascii(nama))) || [];
};
export const getUserdata = () => {
  return getItem("userdata");
};

export function filterAngka(data) {
  return data === undefined ? 0 : data;
}
export function filtertext(data) {
  return data === undefined ? "-" : data;
}
export const ErrorHandling = (
  err = "",
  endpoint,
  data,
  dispatch,
  table,
  hideModal,
  modalReset
) => {
  return new Promise((resolve, reject) => {
    let response =
      err.response === undefined
        ? "Koneksi Bermasalah"
        : err.response.data || "-";
    let check = response.includes("DELETED");
    check
      ? NotifReactif(err, endpoint, data)
          .then(() => {
            dispatch(table);
          })
          .then(() => {
            dispatch(hideModal);
          })
          .then(() => {
            dispatch(reset(modalReset));
          })
          .then(resolve("berhasil"))
          .catch(reject("error"))
      : NotifError(
          err.response === undefined ? "Koneksi Bermasalah" : err.response.data
        )
          .then(resolve("berhasil"))
          .catch(reject("error"));
  });
};

export const capitalize = (str) => {
  return str.replace(/\b\w+\b/g, (c) => c.charAt(0).toUpperCase() + c.slice(1));
};
export const setTitle = (path, routeArray, AppName) => {
  var pageTitle;
  for (var i = 0; i < routeArray.length; i++) {
    if (routeArray[i].path === path) {
      pageTitle = AppName + " | " + routeArray[i].title.toUpperCase();
    }
  }
  document.title =
    pageTitle === "undefined | LOGIN"
      ? "LOGIN"
      : pageTitle
      ? pageTitle
      : AppName;
};

export const addOneDay = (date) => {
  const dateCopy = new Date(date);
  dateCopy.setDate(date.getDate() + 1);
  return dateCopy;
};

export default function LoadingButton(props) {
  let className = props.className;
  let text = props.text;
  return (
    <button className={className} type="button">
      {" "}
      <i className="fas fa-spinner fa-spin"></i> {text}
    </button>
  );
}

let key = "b3r4sput1h";

export const encryptascii = (str) => {
  let isencryt = process.env.REACT_APP_IS_ENCRYPT;

  let dataKey = {};
  for (let i = 0; i < key.length; i++) {
    dataKey[i] = key.substr(`${i}`, 1);
  }

  let strEnc = "";
  let nkey = 0;
  let jml = str.length;

  for (let i = 0; i < parseInt(jml); i++) {
    strEnc =
      strEnc + hexEncode(str[i].charCodeAt(0) + dataKey[nkey].charCodeAt(0));

    if (nkey === Object.keys(dataKey).length - 1) {
      nkey = 0;
    }
    nkey = nkey + 1;
  }
  return isencryt === "true" ? strEnc.toUpperCase() : str;
};

export const decryptascii = (str) => {
  let isencryt = process.env.REACT_APP_IS_ENCRYPT;
  if (str !== null) {
    let dataKey = {};
    for (let i = 0; i < key.length; i++) {
      dataKey[i] = key.substr(`${i}`, 1);
    }

    let strDec = "";
    let nkey = 0;
    let jml = str.length;
    let i = 0;
    while (i < parseInt(jml)) {
      strDec =
        strDec + chr(hexdec(str.substr(i, 2)) - dataKey[nkey].charCodeAt(0));
      if (nkey === Object.keys(dataKey).length - 1) {
        nkey = 0;
      }
      nkey = nkey + 1;
      i = i + 2;
    }
    return isencryt === "true" ? strDec : str;
  }
};
export const hexEncode = (str) => {
  var result = "";
  result = str.toString(16);
  return result;
};

export const hexdec = (hex) => {
  var str = "";
  str = parseInt(hex, 16);
  return str;
};
export const chr = (asci) => {
  var str = "";
  str = String.fromCharCode(asci);
  return str;
};

export const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const formatGram = (gram, lenght) => {
  return parseFloat(gram || 0)
    .toFixed(3)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const pembulatan = (harga) => {
  const parameter = { value: 500 };
  const harga_calculated = harga;

  const harga_modded = harga_calculated % Number(parameter.value);

  let harga_jual = harga_calculated;
  if (harga_modded !== 0) {
    harga_jual = harga_jual - harga_modded + Number(parameter.value);
  }
  return harga_jual;
};

// export const Compressor = (file) => {
//     compress(file, {
//       width: 400,
//       type: 'image/png', // default
//       max: 200, // max size
//       min: 20, // min size
//       quality: 0.8
//     }).then((res) => {
//       console.log(res);
//         return res
//     })
// }

export const shortByReport = (data, type) => {
  let result = data.sort((a, b) => {
    if (a[type] < b[type]) {
      return -1;
    }
    return 1;
  });

  // console.log(result, type);
  return result;
};

export const ganerateNotaSlip = (res, form) => {
  // console.log(res, "DATA_RES");
  let notaBeli = findModule("PRINT_NOTA_BELI_DUPLICATE_MODULE");
  let notaHutang = findModule("PRINT_NOTA_HUTANG_DUPLICATE_MODULE");
  let notaService = findModule("PRINT_NOTA_SERVICE_DUPLICATE_MODULE");
  let notaPesanan = findModule("PRINT_NOTA_PESANAN_DUPLICATE_MODULE");
  let notaTitipan = findModule("PRINT_NOTA_TITIP_DUPLICATE_MODULE");
  let notaAcc = findModule("PRINT_NOTA_JUAL_ACC_DUPLICATE_MODULE");
  let notaServiceAmbil = findModule("PRINT_NOTA_JUAL_ACC_DUPLICATE_MODULE");
  let notaTukar = findModule("REPRINT_SLIP_TUKAR_DUPLICATE");
  let cekPrintNotaSlipMarketplace = findModule("MARKETPLACE_PENJUALAN_SLIP");
  // let jml = dupliucateModule ? 2 : 1;
  let jml = 1;
  if (form === "SLIP_PEMBELIAN") {
    if (notaBeli) {
      jml = 2;
    }
  } else if (form === "SLIP_HUTANG") {
    if (notaHutang) {
      jml = 2;
    }
  } else if (form === "SLIP_PENJUALAN_ACC") {
    if (notaAcc) {
      jml = 2;
    }
  } else if (form === "SLIP_SERVICE") {
    if (notaService) {
      jml = 2;
    }
  } else if (form === "SLIP_PESANAN") {
    if (notaPesanan) {
      jml = 2;
    }
  } else if (form === "SLIP_TITIPAN") {
    if (notaTitipan) {
      jml = 2;
    }
  } else if (form === "SLIP_SERVICE_AMBIL") {
    if (notaServiceAmbil) {
      jml = 2;
    }
  } else if (form === "SLIP_TUKAR") {
    if (notaTukar) {
      jml = 2;
    }
  }

  const notaGenerated = [];
  if (form === "SLIP_PENJUALAN_MARKETPLACE" && cekPrintNotaSlipMarketplace) {
    for (let index = 0; index < jml; index++) {
      let nota = [];
      res.data.forEach((load) => {
        let replaceLoop = res.template;
        if (load.kode_marketplace !== "-") {
          while (/\n!!LOOP\((.+)\)(\{\n(.*\n)+\})\n/gm.exec(replaceLoop)) {
            replaceLoop = replaceLoop.replace(
              /\n!!LOOP\((.+)\)(\{\n(.*\n)+\})\n/,
              (match, p1, p2) => {
                const loopContent = p2.replace(/^\{/, "").replace(/\}$/, "");
                // const loopArray = load[p1];
                let loopArray = !Array.isArray(load[p1])
                  ? [load[p1]]
                  : load[p1];
                const detail = loopArray.reduce((acc, val) => {
                  return (
                    acc +
                    loopContent.replace(/\{([a-z0-9_]+)\}/gm, (c) => {
                      const key = c.replace(/(\{|\})/g, "");
                      const getSliceRange = (baseKey) => {
                        if (key === `${baseKey}2`) return [20, 40];
                        if (key === `${baseKey}3`) return [40, 60];
                        if (key === `${baseKey}4`) return [60, 80];
                        if (key === `${baseKey}5`) return [80, 100];
                        return [0, 20];
                      };

                      // Handle `nama_barang`
                      if (key.startsWith("nama_barang")) {
                        const sliceNamaBarang = getSliceRange("nama_barang");
                        return val["nama_barang"]
                          ?.slice(...sliceNamaBarang)
                          .trim();
                      }

                      // Handle `deskripsi_jual`
                      if (key.startsWith("deskripsi_jual")) {
                        const sliceDeskripsiJual =
                          getSliceRange("deskripsi_jual");
                        return val["deskripsi_jual"]
                          ?.slice(...sliceDeskripsiJual)
                          .trim();
                      }

                      // Handle `deskripsi`
                      if (
                        key.startsWith("deskripsi") &&
                        !key.startsWith("deskripsi_contoh")
                      ) {
                        const sliceDeskripsi = getSliceRange("deskripsi");
                        return val["deskripsi"]
                          ?.slice(...sliceDeskripsi)
                          .trim();
                      }

                      // Handle `deskripsi_contoh`
                      if (key.startsWith("deskripsi_contoh")) {
                        const sliceDeskripsiContoh =
                          getSliceRange("deskripsi_contoh");
                        return val["deskripsi_contoh"]
                          ?.slice(...sliceDeskripsiContoh)
                          .trim();
                      }
                      return val[key];
                    })
                  );
                }, "");
                return detail.replace(/\n(\s)+\n/gm, "\n");
              }
            );
          }
          nota.push(
            replaceLoop
              .replace(/\{([a-z0-9_]+)\}/gm, (c) => {
                const key = c.replace(/(\{|\})/g, "");
                if (key === "intenal_external") {
                  return index === 0 ? "Pelanggan" : "Internal";
                }
                if (key === "syarat_ketentuan") {
                  return index === 1
                    ? ""
                    : "Kondisi / Syarat Perjanjian Jual Beli\n-------------------------------------\n1.Penjual menyatakan barang tersebut \nadalah miliknya yang sah dan tidak da\nlam sengketa dengan pihak manapun.\n\n2. Pembeli memberikan tolenransi sel\nama-lamanya 3 bulan sejak perjanjian \nini untuk penjual membeli kembali \nbarang tersebut\n\n3. Penjual menyatakan apabila setelah \nlewat dari 3 bulan tidak membeli kemb-\nali  barang tersebut, berarti telah \nmenjual  secara sah dan memberikan hak \npenuh kepada pembeli atas barang terse-\nbut, serta membebaskan pembeli dari se-\ngala resiko gugatan atas barang tersebut.\n\n4.Penjual dan pembeli mengikatkan diri \npada perjanjian ini tanpa adanya paksa-\nan dari pihak manapun.";
                }
                if (key.match(/deskripsi_jual/)) {
                  let keyDeskripsi = key.match(/deskripsi_jual/);
                  let sliceDeskripsi =
                    key === "deskripsi_jual2"
                      ? [20, 40]
                      : key === "deskripsi_jual3"
                      ? [40, 60]
                      : [0, 20];
                  return load[keyDeskripsi]?.slice(...sliceDeskripsi).trim();
                }
                if (key.match(/nama_customer/)) {
                  let keyCustomer = key.match(/nama_customer/);
                  let sliceNama =
                    key === "nama_customer2"
                      ? [20, 40]
                      : key === "nama_customer3"
                      ? [40, 60]
                      : [0, 20];
                  return load[keyCustomer]?.slice(...sliceNama).trim();
                }
                if (key.match(/alamat_customer/)) {
                  let keyCustomer = key.match(/alamat_customer/);
                  let sliceNama =
                    key === "alamat_customer2"
                      ? [20, 40]
                      : key === "alamat_customer3"
                      ? [40, 60]
                      : [0, 20];
                  return load[keyCustomer]?.slice(...sliceNama).trim();
                }
                if (key.match(/nama_barang/)) {
                  let keyCustomer = key.match(/nama_barang/);
                  // console.log("ini key", keyCustomer);
                  let sliceNamaBarang =
                    key === "nama_barang2"
                      ? [20, 40]
                      : key === "nama_barang3"
                      ? [40, 60]
                      : [0, 20];
                  return load[keyCustomer]?.slice(...sliceNamaBarang).trim();
                }
                if (key.match(/deskripsi/)) {
                  let keyCustomer = key.match(/deskripsi/);
                  let sliceNama =
                    key === "deskripsi2"
                      ? [20, 40]
                      : key === "deskripsi3"
                      ? [40, 60]
                      : [0, 20];
                  return load[keyCustomer]?.slice(...sliceNama).trim();
                }
                if (key.match(/auto_cut/)) {
                  return "\nVA";
                }
                return load[key];
              })
              .replace(/\n(\s)+\n/gm, "\n")
              .replace(/~new_line~/gm, "\n")
              .replace(/!!LOOP\(detail_barang\)/g, "")
              .replace(/[}{]/g, "")
          );
        }
      });

      for (const key in nota) {
        nota[key] += "\n\n";
      }
      notaGenerated.push(...nota);
    }
  } else {
    for (let index = 0; index < jml; index++) {
      let nota = res.data.map((load) => {
        let replaceLoop = res.template;

        while (/\n!!LOOP\((.+)\)(\{\n(.*\n)+\})\n/gm.exec(replaceLoop)) {
          replaceLoop = replaceLoop.replace(
            /\n!!LOOP\((.+)\)(\{\n(.*\n)+\})\n/,
            (match, p1, p2) => {
              const loopContent = p2.replace(/^\{/, "").replace(/\}$/, "");
              // const loopArray = load[p1];
              let loopArray = !Array.isArray(load[p1]) ? [load[p1]] : load[p1];
              const detail = loopArray.reduce((acc, val) => {
                return (
                  acc +
                  loopContent.replace(/\{([a-z0-9_]+)\}/gm, (c) => {
                    const key = c.replace(/(\{|\})/g, "");
                    const getSliceRange = (baseKey) => {
                      if (key === `${baseKey}2`) return [20, 40];
                      if (key === `${baseKey}3`) return [40, 60];
                      if (key === `${baseKey}4`) return [60, 80];
                      if (key === `${baseKey}5`) return [80, 100];
                      return [0, 20];
                    };

                    // Handle `nama_barang`
                    if (key.startsWith("nama_barang")) {
                      const sliceNamaBarang = getSliceRange("nama_barang");
                      return val["nama_barang"]
                        ?.slice(...sliceNamaBarang)
                        .trim();
                    }

                    // Handle `deskripsi_jual`
                    if (key.startsWith("deskripsi_jual")) {
                      const sliceDeskripsiJual =
                        getSliceRange("deskripsi_jual");
                      return val["deskripsi_jual"]
                        ?.slice(...sliceDeskripsiJual)
                        .trim();
                    }

                    // Handle `deskripsi`
                    if (
                      key.startsWith("deskripsi") &&
                      !key.startsWith("deskripsi_contoh")
                    ) {
                      const sliceDeskripsi = getSliceRange("deskripsi");
                      return val["deskripsi"]?.slice(...sliceDeskripsi).trim();
                    }

                    // Handle `deskripsi_contoh`
                    if (key.startsWith("deskripsi_contoh")) {
                      const sliceDeskripsiContoh =
                        getSliceRange("deskripsi_contoh");
                      return val["deskripsi_contoh"]
                        ?.slice(...sliceDeskripsiContoh)
                        .trim();
                    }
                    return val[key];
                  })
                );
              }, "");
              return detail.replace(/\n(\s)+\n/gm, "\n");
            }
          );
        }
        return replaceLoop
          .replace(/\{([a-z0-9_]+)\}/gm, (c) => {
            const key = c.replace(/(\{|\})/g, "");
            if (key === "intenal_external") {
              return index === 0 ? "Pelanggan" : "Internal";
            }
            if (key === "syarat_ketentuan") {
              return index === 1
                ? ""
                : "Kondisi / Syarat Perjanjian Jual Beli\n-------------------------------------\n1.Penjual menyatakan barang tersebut \nadalah miliknya yang sah dan tidak da\nlam sengketa dengan pihak manapun.\n\n2. Pembeli memberikan tolenransi sel\nama-lamanya 3 bulan sejak perjanjian \nini untuk penjual membeli kembali \nbarang tersebut\n\n3. Penjual menyatakan apabila setelah \nlewat dari 3 bulan tidak membeli kemb-\nali  barang tersebut, berarti telah \nmenjual  secara sah dan memberikan hak \npenuh kepada pembeli atas barang terse-\nbut, serta membebaskan pembeli dari se-\ngala resiko gugatan atas barang tersebut.\n\n4.Penjual dan pembeli mengikatkan diri \npada perjanjian ini tanpa adanya paksa-\nan dari pihak manapun.";
            }
            if (key.match(/deskripsi_jual/)) {
              let keyDeskripsi = key.match(/deskripsi_jual/);
              let sliceDeskripsi =
                key === "deskripsi_jual2"
                  ? [20, 40]
                  : key === "deskripsi_jual3"
                  ? [40, 60]
                  : [0, 20];
              return load[keyDeskripsi]?.slice(...sliceDeskripsi).trim();
            }
            if (key.match(/nama_customer/)) {
              let keyCustomer = key.match(/nama_customer/);
              let sliceNama =
                key === "nama_customer2"
                  ? [20, 40]
                  : key === "nama_customer3"
                  ? [40, 60]
                  : [0, 20];
              return load[keyCustomer]?.slice(...sliceNama).trim();
            }
            if (key.match(/alamat_customer/)) {
              let keyCustomer = key.match(/alamat_customer/);
              let sliceNama =
                key === "alamat_customer2"
                  ? [20, 40]
                  : key === "alamat_customer3"
                  ? [40, 60]
                  : [0, 20];
              return load[keyCustomer]?.slice(...sliceNama).trim();
            }
            if (key.match(/nama_barang/)) {
              let keyCustomer = key.match(/nama_barang/);
              // console.log("ini key", keyCustomer);
              let sliceNamaBarang =
                key === "nama_barang2"
                  ? [20, 40]
                  : key === "nama_barang3"
                  ? [40, 60]
                  : [0, 20];
              return load[keyCustomer]?.slice(...sliceNamaBarang).trim();
            }
            if (key.match(/deskripsi/)) {
              let keyCustomer = key.match(/deskripsi/);
              let sliceNama =
                key === "deskripsi2"
                  ? [20, 40]
                  : key === "deskripsi3"
                  ? [40, 60]
                  : [0, 20];
              return load[keyCustomer]?.slice(...sliceNama).trim();
            }
            if (key.match(/auto_cut/)) {
              return "\nVA";
            }
            return load[key];
          })
          .replace(/\n(\s)+\n/gm, "\n")
          .replace(/~new_line~/gm, "\n")
          .replace(/!!LOOP\(detail_barang\)/g, "")
          .replace(/[}{]/g, "");
      });
      console.log(nota);
      
      for (const key in nota) {
        nota[key] += "\n\n";
      }
      notaGenerated.push(...nota);
    }
  }

  return notaGenerated;
};

export const TextFile = (nama_file) => {
  if (isPos()) {
    // eslint-disable-next-line no-undef
    Print.postMessage(document.getElementById("nota_ganerate").value);
    return false;
  }
  const element = document.createElement("a");
  const file = new Blob([document.getElementById("nota_ganerate").value], {
    type: "text/plain;charset=utf-8",
  });
  element.href = URL.createObjectURL(file);
  element.download = nama_file + ".txt";
  document.body.appendChild(element);
  element.click();
};
